export interface JobApplicant {
    applicationId: string;
    jobId: string;
    userId: string;
    cvId: string;
    name: string;
    gender?: number;
    education?: number;
    firstWorkDate?: string;
    phone?: string;
    expectedSalaryStart?: number;
    expectedSalaryEnd?: number;
    status: string;
    appliedAt: string | Date;
}

export type ApplicationManageStatus = "reviewing" | "accepted" | "rejected";

export const getApplicationStatusText = (status: string): string => {
    switch (status) {
        case "pending":
            return "待处理";
        case "reviewing":
            return "审核中";
        case "accepted":
            return "已录用";
        case "rejected":
            return "已拒绝";
        case "withdrawn":
            return "已撤回";
        default:
            return status || "未知";
    }
};
